/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
/* eslint-disable */

/**
* このファイルは自動生成されています。そのためgit管理には含まれません。手動で編集してもdeploy時反映されません。
*/

/**
 * 車両状況 (1:配車依頼中, 2:配車応答OK, 3:配車応答NG, 4:タイムアウト, 5:別車両検索中)
 * @export
 * @enum {number}
 */
export enum ActivityEnum {
    /** 配車依頼中 */
    DISPATCH_REQUESTED = 1,
    /** 配車応答OK */
    DISPATCH_OK = 2,
    /** 配車応答NG */
    DISPATCH_NG = 3,
    /** タイムアウト */
    TIMEOUT = 4,
    /** 別車両検索中 */
    SEARCHING_OTHER_CAR = 5
}

/**
 * 車両状況 (1:配車依頼中, 2:配車応答OK, 3:配車応答NG, 4:タイムアウト, 5:別車両検索中) の Union 型
 * @export
 * @typedef Activity
 */
export type Activity =
  typeof ActivityEnum[keyof typeof ActivityEnum];

/**
 * 車両状況 (1:配車依頼中, 2:配車応答OK, 3:配車応答NG, 4:タイムアウト, 5:別車両検索中) のラベルマップ
 * @export
 */
export const ActivityLabels = {
    /**
     * 数値キー: ActivityEnum.DISPATCH_REQUESTED
     * 名前キー:  DISPATCH_REQUESTED
     */
    [ActivityEnum.DISPATCH_REQUESTED]: '配車依頼中',
    DISPATCH_REQUESTED:                             '配車依頼中',
    /**
     * 数値キー: ActivityEnum.DISPATCH_OK
     * 名前キー:  DISPATCH_OK
     */
    [ActivityEnum.DISPATCH_OK]: '配車応答OK',
    DISPATCH_OK:                             '配車応答OK',
    /**
     * 数値キー: ActivityEnum.DISPATCH_NG
     * 名前キー:  DISPATCH_NG
     */
    [ActivityEnum.DISPATCH_NG]: '配車応答NG',
    DISPATCH_NG:                             '配車応答NG',
    /**
     * 数値キー: ActivityEnum.TIMEOUT
     * 名前キー:  TIMEOUT
     */
    [ActivityEnum.TIMEOUT]: 'タイムアウト',
    TIMEOUT:                             'タイムアウト',
    /**
     * 数値キー: ActivityEnum.SEARCHING_OTHER_CAR
     * 名前キー:  SEARCHING_OTHER_CAR
     */
    [ActivityEnum.SEARCHING_OTHER_CAR]: '別車両検索中',
    SEARCHING_OTHER_CAR:                             '別車両検索中',
} as const;

/**
 * 車両状況 (1:配車依頼中, 2:配車応答OK, 3:配車応答NG, 4:タイムアウト, 5:別車両検索中) のラベル Union 型
 * @export
 * @typedef ActivityLabel
 */
export type ActivityLabel =
  typeof ActivityLabels[keyof typeof ActivityLabels];

/**
 * 車両状況 (1:配車依頼中, 2:配車応答OK, 3:配車応答NG, 4:タイムアウト, 5:別車両検索中) のラベル取得関数
 * @export
 * @param { Activity } value - 列挙体の値
 * @returns { ActivityLabel } ラベル文字列
 */
export function getActivityLabel(
  value: Activity
): ActivityLabel {
  return ActivityLabels[value];
}

/**
 * 車両状況 (1:配車依頼中, 2:配車応答OK, 3:配車応答NG, 4:タイムアウト, 5:別車両検索中) のラベル配列を取得する関数
 * @export
 * @param { Activity[] } values - 列挙体の値配列
 * @returns { ActivityLabel[] } ラベル文字列配列
 */
export function getActivityLabels(values: Activity[]): ActivityLabel[] {
  return values.map((value) => getActivityLabel(value));
}

/**
 * 車両状況 (1:配車依頼中, 2:配車応答OK, 3:配車応答NG, 4:タイムアウト, 5:別車両検索中) のラベル配列
 * @export
 */
export const ActivityLabelList = [
  '配車依頼中','配車応答OK','配車応答NG','タイムアウト','別車両検索中',
] as const;

